import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GetTrainingData, HomeAssignment, TrainingData, StudentCurriculumVisibilityData, ApiClientData, StudentSubjectData } from './home-types';
// import { ResponseContentType } from '@angular/http';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  readonly getStudentTrainingUrl = '/student/getTraining';
  readonly getStudentSubjectsUrl = '/student/getSubjects';
  readonly getStudentCurriculumVisibilityUrl = '/student/getCurriculumVisibility';
  readonly getStudentCalendarUrl = '/student/calendar';
  readonly getStudentUrl = '/student/getInfo'
  readonly getRegistrarHomepageDataUrl = '/learningCenter/getRegistrarHomepageData';
  readonly getManagerHomepageDataUrl = '/learningCenter/getManagerHomepageData';
  readonly getStudentsCoursesUrl = '/learningCenter/getStudentsCourses';
  readonly getStudentsMemosUrl = '/learningCenter/getStudentsMemos';
  readonly getUsersLoginsUrl = '/learningCenter/getUsersLogins';
  readonly getSurveysUrl = '/records/getSurveyList';
  readonly getTrainingDataUrl = '/learningCenter/getTrainingData';

  readonly getApiAppsUrl = '/developer/getApiApps';
  readonly saveApiAppUrl = '/developer/saveApp.json';
  readonly deleteApiAppUrl = '/developer/deleteApp.json';
  readonly revokeAccessTokensUrl = '/developer/revokeAccessTokens.json';
  readonly regenerateClientSecretUrl = '/developer/regenerateClientSecret.json';

  constructor(private http: HttpClient) {}

  public getStudentTraining(userId?: string) {
    if (userId)
    {
      return this.http.get<GetTrainingData | HomeAssignment[]>(`${this.getStudentTrainingUrl}?userId=${userId}`);
    }

    return this.http.get<GetTrainingData | HomeAssignment[]>(this.getStudentTrainingUrl);
  }

  public getStudentSubjects(userId?: string) {
    if (userId)
    {
      return this.http.get<StudentSubjectData[]>(`${this.getStudentSubjectsUrl}?userId=${userId}`);
    }

    return this.http.get<StudentSubjectData[]>(this.getStudentSubjectsUrl);
  }

  public getStudentCurriculumVisibility() {
    return this.http.get<StudentCurriculumVisibilityData[]>(this.getStudentCurriculumVisibilityUrl);
  }

  public getStudentCalendar() {
    return this.http.get<string>(this.getStudentCalendarUrl, { responseType: 'text' as 'json' });
  }

  public getStudent() {
    return this.http.get(this.getStudentUrl, { responseType: 'text' as 'json' });
  }

  public getTrainingData() {
    return this.http.get<TrainingData>(this.getTrainingDataUrl);
  }

  public getSurveyData() {
    return this.http.get<TrainingData>(this.getSurveysUrl);
  }

  public getApiApps() {
    return this.http.get<ApiClientData[]>(this.getApiAppsUrl);
  }

  public saveApiApp(app: ApiClientData) {
    return this.http.post<ApiClientData>(this.saveApiAppUrl, app);
  }

  public deleteApiApp(clientId: string) {
    return this.http.post<string>(this.deleteApiAppUrl, {client_id: clientId});
  }

  public revokeAccessTokens(clientId: string) {
    return this.http.post<string>(this.revokeAccessTokensUrl, {client_id: clientId});
  }

  public regenerateClientSecret(clientId: string) {
    return this.http.post<{secret: string}>(this.regenerateClientSecretUrl, {client_id: clientId});
  }

}
